import { useState } from "react";
import logo from "../assets/epu-icon.png";
import "./Header.css";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className="site-header">
      <div className="header-inner">

        {/* LEFT: LOGO + DESKTOP NAV */}
        <div className="header-left">

          <a href="#top" className="header-logo">
            <img
              src={logo}
              alt="EPU Index.PL — Economic Policy Uncertainty Index for Poland"
            />
          </a>

          {/* DESKTOP NAV */}
          <nav className="desktop-nav" data-desknav="1">
            <a href="/product.html">The Index</a>
            <a href="/methodology.html">Methodology</a>
            <a href="/research.html">Research</a>
            <a href="/data">Data</a>
          </nav>
        </div>

        {/* RIGHT: LOGIN + DEMO + MOBILE MENU */}
        <div className="header-right">

          {/* BOOK A DEMO */}
          <a
            href="contact.html"
            className="demo-button"
            data-keep="1"
          >
            Contact us
          </a>

          {/* MOBILE MENU BUTTON */}
          <button
            type="button"
            className="mobile-menu-button"
            data-mobonly="1"
            onClick={toggleMenu}
            aria-label="Menu"
            aria-expanded={menuOpen}
          >
            <span className="hamburger">
              <span />
              <span />
              <span />
            </span>
          </button>
        </div>
      </div>

      {/* MOBILE NAVIGATION */}
      {menuOpen && (
        <div className="mobile-navigation">

          <a href="/product.html" onClick={closeMenu}>
            The Index
          </a>

          <a href="/methodology.html" onClick={closeMenu}>
            Methodology
          </a>

          <a href="/research.html" onClick={closeMenu}>
            Research
          </a>

          <a href="/data" onClick={closeMenu}>
            Data
          </a>


          <a href="/contact.html" onClick={closeMenu}>
            Contact us
          </a>

        </div>
      )}
    </header>
  );
}

export default Header;

